// extracted by mini-css-extract-plugin
module.exports = {"carousel":"carousel_carousel__3FVj4","arrow":"carousel_arrow__1aTOb","container":"carousel_container__34pp7"};